import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Component to initialize authentication state
 * This should be placed inside the Router but after AuthProvider
 */
const AuthInitializer = () => {
  const { checkAuth } = useAuth();
  
  useEffect(() => {
    const validateAuth = async () => {
      try {
        await checkAuth();
        console.log('Auth check completed');
      } catch (error) {
        console.error('Auth check failed:', error);
      }
    };
    
    validateAuth();
  }, [checkAuth]);
  
  // This component doesn't render anything
  return null;
};

export default AuthInitializer;